<template>
    <el-calendar v-model="value" class="myCalendar">
</el-calendar>
</template>

<script>
export default {
  name: 'Calendar',
  data () {
    return {
      value: new Date()
    }
  }
}
</script>

<style>
.myCalendar {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    width: 70%;
    margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Calendar/Calendar.vue